<script setup>
import i18n from "@/i18n"
import { ref, defineProps, defineEmits, watch } from "vue";
// import Swal from "sweetalert2";
import { useRoute } from "vue-router";
import { getLangValue } from "@/utils/common"; //获取后端语言
const props = defineProps({
    customTableList: {
        type: Array,
        required: true,
        default: () => []
    },
})
const route = useRoute()
const emits = defineEmits(["update:customTableList"])
// const { customTableList } = toRefs(props)
const customTableList = ref(props.customTableList);

watch(() => props.customTableList, (newVal) => {
    customTableList.value = newVal;
});

//方法

// const addField = (index) => {
//     customTableList.value[index].tableList.push({
//         value1: "",
//         value2: "",
//     })
//     emits('update:customTableList', customTableList.value)
// }
// const deleteField = (index, index_field) => {
//     const { tableList } = customTableList.value[index]
//     tableList.splice(index_field, 1)
//     emits('update:customTableList', customTableList.value)
// }
const changeValue = () => {
    emits('update:customTableList', customTableList.value)
}

// const deleteTable = (index) => {
//     Swal.fire({
//         title: i18n.global.t("base.delete_alert_title"),
//         text: i18n.global.t("base.delete_alert_info"),
//         icon: "warning",
//         showCancelButton: true,
//         cancelButtonColor: "#f46a6a",
//         confirmButtonColor: "#34c38f",
//         confirmButtonText: i18n.global.t("base.done"),
//         cancelButtonText: i18n.global.t("base.cancel"),
//     }).then(async (result) => {
//         if (result.isConfirmed) {
//             customTableList.value.splice(index, 1)
//             emits('update:customTableList', customTableList.value)
//         }
//     });

// }

</script>
<template>
    <div v-for="(item, index) in customTableList" :key="index">
        <div class="row gy-3 w-100">
            <div class="d-flex justify-content-between align-items-center  pb-2"
                style="font-weight: bold;border-bottom: 1px solid #E9EBEC; font-size: 16px;">
                <div>
                    <label class="form-label">
                        <span>{{ i18n.global.locale == 'en' ? item.name_en : item.name  }}</span>
                    </label>
                </div>
                <!-- <div>
                    <button :disabled="route.query.type == 'view'" type="button" class="btn btn-success me-3" style="background-color: #0AB39C;"
                        @click="addField(index)">
                        <i class="ri-add-fill me-1 align-bottom"></i>
                        {{ $t("base.add") }}
                    </button>
                    <button :disabled="route.query.type == 'view'"  v-show="item.showDelete" type="button" class="btn btn-success me-3" style="background-color: #F06548;"
                        @click="deleteTable(index)">
                        <i class="ri-delete-bin-5-fill me-1 align-bottom"></i>
                        {{ $t("base.delete") }}
                    </button>
                </div> -->
            </div>
            <!-- 显示表格 -->
            <table class="table table-bordered table-nowrap">
                <thead class="table-light">
                    <tr>
                        <th scope="col" width="25%" v-for="(header, index_header) in item.headerList"
                            :key="index_header">{{ getLangValue(header) }}</th>
                        <!-- <th scope="col" width="25%">{{ $t("base.operation") }}</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr style="vertical-align: middle" v-for="(tableData, index_data) in item.tableList"
                        :key="index_data">
                        <td>{{ `#${index_data + 1}` }}</td>
                        <!-- <td>{{ tableData.value1 }}</td> -->
                        <!-- <td>{{ tableData.value2 }}</td> -->
                        <td><input  :disabled="route.query.type == 'view'" v-model="tableData.value1" class="form-control" style="width:100%"
                                @change="changeValue" /></td>
                        <td><input  :disabled="route.query.type == 'view'" v-model="tableData.value2" class="form-control" style="width:100%"
                                @change="changeValue" /></td>
                        <!-- <td><i v-if="route.query.type !== 'view'" class="bx bx-minus-circle cursor-pointer" @click="deleteField(index, index_data)"
                                style="color: #4676e9;"></i></td> -->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

</template>
<style></style>